import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class EndpointResponseInterceptor implements HttpInterceptor {

    constructor(private snackBar: MatSnackBar) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            map(event => {

                if (!(event instanceof HttpResponse)) {
                    return event;
                }

                const body = event.body;

                if (!this.isEndpointResponse(body)) {
                    return event;
                }

                const isSuccess = body.isSuccess ?? body.IsSuccess;
                const value = body.value ?? body.Value;
                const error = body.error ?? body.Error;

                if (!isSuccess) {
                    this.snackBar.open(error, 'X', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });

                    throw new Error(error);
                }

                return event.clone({ body: value });
            })
        );
    }

    private isEndpointResponse(obj: any): boolean {
        return obj &&
            typeof obj === 'object' &&
            (typeof obj.isSuccess === 'boolean' || typeof obj.IsSuccess === 'boolean') &&
            (obj.hasOwnProperty('error') || obj.hasOwnProperty('Error')) &&
            (obj.hasOwnProperty('value') || obj.hasOwnProperty('Value'));
    }


}
